module.exports = __webpack_public_path__ + "static/img/plate_title_1.7dc4736.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/plate_title_1.png
// module id = uwFN
// module chunks = 60